import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {PasswordValidatorDirective} from "./password-validator.directive";

@NgModule({
  imports: [
    FormsModule
  ],
  declarations: [PasswordValidatorDirective],
  exports: [PasswordValidatorDirective]
})
export class PasswordValidatorModule {}
